module.exports = __webpack_public_path__ + "img/142.once_a_month.08cfee17.svg";